











































import Vue from 'vue';
import Component from 'vue-class-component';
import { ticketsDashboard, user } from '@/modules/shared/shared/store/namespaces';
import { HAS_PRIVILEGES_OF_READ_TICKETS } from '@/modules/users/store/user.getters';
import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';

@Component({})
export default class TicketsHeaderCards extends Vue {
    @user.Getter(HAS_PRIVILEGES_OF_READ_TICKETS)
    AS_PRIVILEGES_OF_READ_TICKETS;

    @ticketsDashboard.State('tickets') tickets;

    isLoading: boolean = true;

    get descriptions() {
        return [
            'Ticket en progreso o en espera de acciones o información.',
            'Aplicadas las acciones requeridas, tiene tiempo de garantía de dos (2) días.',
            'Has manifestado conformidad con la solución o ya ha transcurrido el tiempo de garantía.',
            'Sumatoria de tickets en el período de estatus abierto, solucionado y cerrado.',
        ];
    }

    get summaryTickets() {
        if (this.tickets && this.tickets.values !== undefined) {
            this.isLoading = false;

            return [
                {
                    title: this.tickets.values.ticketsRecord[0].status,
                    count: this.tickets.values.ticketsRecord[0].total,
                    class: 'summary-opened-tickets',
                    titleClass: 'summary-tickets--title',
                },
                {
                    title: this.tickets.values.ticketsRecord[2].status,
                    count: this.tickets.values.ticketsRecord[2].total,
                    class: 'summary-solved-tickets',
                    titleClass: 'summary-tickets--title',
                },
                {
                    title: TicketStatus.CLOSED,
                    count: this.tickets.values.ticketsRecord[1].total,
                    class: 'summary-closed-tickets',
                    titleClass: 'summary-tickets--title',
                },
                {
                    title: 'Total',
                    count: this.tickets.values.tickets.total,
                    class: 'summary-total-tickets',
                    titleClass: 'summary-tickets--title',
                },
            ];
        }

        return [];
    }
}
